export default __webpack_public_path__ + "static/media/P316.3.cb0fa4b5.mp3";